import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomToggle } from '../shared/CustomToggle';
import './header.css';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();

  // Initialize state from localStorage (fallback to 'de')
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved === 'fr' || saved === 'de' ? saved : 'de';
  });

  // Keep i18n in sync with localStorage language
  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, [language, i18n]);

  const handleChange = (isFrench: boolean): void => {
    setLanguage(isFrench ? 'fr' : 'de');
  };

  return (
    <span className="language-toggle">
      <Grid component="label" container sx={{ alignItems: 'center', gap: 1 }}>
        <Grid>
          <Typography variant="subtitle1">DE</Typography>
        </Grid>
        <Grid>
          <CustomToggle
            checked={language === 'fr'}
            onChange={handleChange}
            color="secondary"
          />
        </Grid>
        <Grid>
          <Typography variant="subtitle1">FR</Typography>
        </Grid>
      </Grid>
    </span>
  );
};

export default LanguageToggle;
